import angular from 'angular';
import { schedule, options, generateOptions } from '../../utils';
import { get, includes, forEach, cloneDeep, defaultTo } from 'lodash';
import 'angular-ui-tree';
import '../../services/organization-area';
import '../../services/errors';
import '../../components/osom';
import '../../components/schedule/exact-schedules';

const module = angular.module('whyline.modals.organization-area', [
  'whyline.services.organization-area',
  'whyline.services.errors',
  'whyline.components.osom',
  'whyline.components.exactSchedule',
]);

const OrganizationAreaModalController = ($scope, $timeout, $state, $uibModalInstance, $translate, GlobalsService, NotificationService, OrganizationAreaService, organizationAreaId, ErrorService) => {
  'ngInject';
  $scope.loader = true;  

  const urlPattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/i;
  $scope.blockSaveButton = false;
  $scope.products = [];
  $scope.selectedProducts = [];
  $scope.productSettings = {
    template: '<translate>{{option.name}}</translate>',
    externalIdProp: '',
    displayProp: 'name',
    idProp: '_id',
    enableSearch: false,
    keyboardControls: true,
    selectedToTop: false,
    showCheckAll: false,
    showUncheckAll: false,
    closeOnSelect: false,
    smartButtonMaxItems: 3,
    smartButtonTextConverter: (itemText, item) => item.name
  };

  $scope.multiselectTranslations = {
    checkAll: $translate.instant('multiselect_todos'),
    uncheckAll: $translate.instant('multiselect_ninguno'),
    dynamicButtonTextSuffix: $translate.instant('multiselect_seleccionados'),
    buttonDefaultText: $translate.instant('multiselect_seleccionar'),
    searchPlaceholder: $translate.instant('multiselect_buscar'),
  };

  const organizationId = GlobalsService.CurrentOrganization._id;

  const Init = async () => {
    $scope.products = await OrganizationAreaService.GetAssociatedProducts(organizationId, $translate.use());
  }

  Init();

  $scope.exactSchedule = schedule.reOrder(schedule.createExactDaySchedule());

  const populateAlreadyShown = () => {
    $scope.itemsPopulated = {};
    forEach($scope.items, line => {
      $scope.itemsPopulated[line._id] = line;
    });
  };

  $scope.saveWithoutAppointment = () => {
    if ($scope.validateWithoutAppointment($scope.organizationArea.withoutAppointment)) {
      const data = {
        updateType: $scope.selectData.selectedOption,
        updateValues: { withoutAppointment: $scope.organizationArea.withoutAppointment }
      };
      $scope.save(data).then(() => {
        $scope.editStatus.withoutAppointment = cloneDeep($scope.organizationArea.withoutAppointment);
        $scope.editStatus.openEditingWithout = false;
      });
    }
  };

  $scope.saveLines = () => {
    if ($scope.validateLines($scope.items)) {
      const data = {
        updateType: $scope.selectData.selectedOption,
        updateValues: { organizationLines: $scope.items.map(item => item._id) }
      };
      $scope.save(data).then(() => {
        $scope.editStatus.items = cloneDeep($scope.items);
        $scope.editStatus.openEditingLines = false;
      });
    }
  };

  $scope.saveMessages = () => {
    const data = {
      updateType: $scope.selectDataMessages.selectedOption,
      updateValues: { configuration: $scope.organizationArea.configuration },
    };
    $scope.save(data).then(() => {
      $scope.editStatus.messages = cloneDeep($scope.organizationArea.configuration.messages);
      $scope.editStatus.editingMessages = false;
    });
  };

  $scope.saveSchedule = () => {
    schedule.scheduleFormat($scope.organizationArea.schedule, $scope.exactSchedule, false);
    if ($scope.validateRanges($scope.organizationArea.schedule)) {
      const data = {
        updateType: $scope.selectData.selectedOption,
        updateValues: { schedule: $scope.organizationArea.schedule }
      };
      $scope.save(data).then(() => {
        $scope.editStatus.schedule = cloneDeep($scope.organizationArea.schedule);
        $scope.editStatus.openEditingDayList = false;
      });
    }
  };

  $scope.editLines = () => {
    $scope.editStatus.openEditingLines = true;
    $scope.selectData.selectedOption = 'all';
  };
  const selectProducts = ()=>{
    if(!$scope.getAssociatedProducts.length) {
      return [];
    }
    return $scope.products.filter(products => $scope.getAssociatedProducts.includes(products._id));
  }

  $scope.editAssociatedProducts = () => {
    $scope.selectedProducts = selectProducts();
    $scope.editStatus.openAssociatedProducts = true;
  };

  $scope.saveAssociatedProducts = () => {
    const data = {
      updateType: $scope.selectAssociatedProducts.selectedOption,
      updateValues: { associatedProducts: $scope.selectedProducts.map(product => product._id) }
    };

    $scope.save(data).then((res) => {
      if(res){
        $scope.associatedProductsToString = $scope.selectedProducts.map(product => product.name).toString();
        $scope.getAssociatedProducts = $scope.selectedProducts.map(product => product._id).toString();
        $scope.editStatus.openAssociatedProducts = false;
      }
    });
  }

  $scope.validateRanges = schedule => {
    var valid = true;
    const opened = schedule.filter(s => s.open);
    for (let i = 0; i < opened.length; i++) {
      const day = opened[i];
      if (day.firstPeriod.opening >= day.firstPeriod.closing) {
        NotificationService.Warning($translate.instant('opening_hours_first_period_msg_validator').replace('{dayname}', $translate.instant(day.name)));
        valid = false;
        break;
      }
      if (day.hasSecondPeriod) {
        if (day.secondPeriod.opening <= day.firstPeriod.closing) {
          NotificationService.Warning($translate.instant('opening_hours_second_must_be_later_first_msg_validator').replace('{dayname}', $translate.instant(day.name)));
          valid = false;
          break;
        }

        if (day.secondPeriod.opening >= day.secondPeriod.closing) {
          NotificationService.Warning($translate.instant('opening_hours_second_period_msg_validator').replace('{dayname}', $translate.instant(day.name)))
          valid = false;
          break;
        }
      }
    }
    return valid;
  };

  $scope.validateWithoutAppointment = withoutAppointment => {
    if (!withoutAppointment.withPriority && !withoutAppointment.withoutPriority) {
      NotificationService.Warning($translate.instant('min_one_priority_type'));
      return false;
    }

    if (!withoutAppointment.requestSource.reception && !withoutAppointment.requestSource.totem && !withoutAppointment.requestSource.mobileApp) {
      NotificationService.Warning($translate.instant('min_one_request_type'));
      return false;
    }

    return true;
  };

  $scope.validateLabel = name => {
    if (!name) {
      NotificationService.Warning($translate.instant('mandatory_area_name'));
      return false;
    }

    if (name.length > 50) {
      NotificationService.Warning($translate.instant('max_length_name'));
      return false;
    }

    if (!/^[ '-:A-Za-z\xC0-\xCF\xD1-\xD6\xD8-\xDD\xDF-\xE5\xE7-\xF6\xF8-\xFD\xFF\u0104-\u0107\u010C\u010D\u0116-\u0119\u012E\u012F\u0141-\u0144\u0152\u0160\u0161\u016A\u016B\u0172\u0173\u0178-\u017E]+$/.test(name)) {
      NotificationService.Warning($translate.instant('char_forbidden_name'));
      return false;
    }

    return true;
  };

  $scope.validateRequestType = values => {
    if (!values.isWithAppointment && !values.isWithoutAppointment) {
      NotificationService.Warning($translate.instant('min_one_request_type'));
      return false;
    }
    return true;
  };

  $scope.validateLines = items => {
    if (items.length <= 0) {
      NotificationService.Warning($translate.instant('min_fila_assign'));
      return false;
    }
    return true;
  };

  $scope.validateMessage = postMessage => {
    if (postMessage.length > 59) {
      NotificationService.Warning($translate.instant('max_length_post_check_in_message'));
      return false;
    }
    return true;
  };

  const validate = () => {
    const preJoin = get($scope, 'organizationArea.configuration.messages.preJoin', {
      text: '',
      button: {
        label: '',
        url: '',
      },
    });
    const preJoinButtonLabel = get(preJoin, 'button.label', '');
    const preJoinButtonUrl = get(preJoin, 'button.url', '');

    if (!$scope.validateLabel($scope.organizationArea.label)) {
      return false;
    }
    if (!$scope.validateMessage(get($scope.organizationArea.configuration, 'postMessage', ''))) {
      return false;
    }
    if (!$scope.validateLines($scope.items)) {
      return false;
    }
    if (get(preJoin, 'text') && preJoin.text.length > 300) {
      NotificationService.Warning($translate.instant('max_length_pre_join_message'));
      return false;
    }
    if (preJoinButtonLabel && preJoinButtonUrl && !get(preJoin, 'text')) {
      NotificationService.Warning($translate.instant('prejoin_empty_text'));
      return false;
    }
    if (!preJoinButtonLabel && preJoinButtonUrl) {
      NotificationService.Warning($translate.instant('button-label-mandatory'));
      return false;
    }
    if (preJoinButtonLabel && !preJoinButtonUrl) {
      NotificationService.Warning($translate.instant('button-url-mandatory'));
      return false;
    }
    if (preJoinButtonLabel && preJoinButtonUrl) {
      if (preJoinButtonLabel.length > 22) {
        NotificationService.Warning($translate.instant('button-label-max-length'));
        return false;
      }
      if (!urlPattern.test(preJoinButtonUrl)) {
        NotificationService.Warning($translate.instant('button-url-invalid'));
        return false;
      }
    }
    const requestTypes = {
      isWithAppointment: $scope.organizationArea.isWithAppointment,
      isWithoutAppointment: $scope.organizationArea.isWithoutAppointment
    };
    if (!$scope.validateRequestType(requestTypes)) {
      return false;
    }
    if ($scope.organizationArea.isWithoutAppointment && !$scope.validateWithoutAppointment($scope.organizationArea.withoutAppointment)) {
      return false;
    }
    if (!$scope.validateRanges($scope.organizationArea.schedule)) {
      return false;
    }

    return true;
  };

  $scope.selectData = {
    options: options.filter(o => o.onlyOrganizations || o.all),
    selectedOption: options.filter(o => o.onlyOrganizations || o.all)[0].key,
  };

  $scope.enterpriseType = GlobalsService.EnterpriseType;

  $scope.selectDataMessages = {
    options: options.filter(o => o.onlyOrganizations || o.all),
    selectedOption: options.filter(o => o.onlyOrganizations || o.all)[0].key,
  };

  $scope.selectDataForWithoutAppointment = {
    options: options.filter(o => o.onlyOrganizations || o.all),
    selectedOption: options.filter(o => o.onlyOrganizations || o.all)[0].key,
  };

  $scope.selectAssociatedProducts = generateOptions();

  $scope.items = [];
  $scope.hours = schedule.getHours();
  $scope.organizationArea = {
    schedule: schedule.reOrder(schedule.create()),
    maxNumbers: 0,
    isWithoutAppointment: true,
    isWithAppointment: $scope.enterpriseType === 'ba',
    withoutAppointment: {
      withPriority: true,
      withoutPriority: true,
      requestSource: {
        mobileApp: true,
        reception: true,
        totem: true,
      }
    },
    configuration: {
      postMessage: ''
    },
    associatedProducts:[],
  };
  $scope.showEditAttributes = false;

  if (organizationAreaId) {
    OrganizationAreaService.GetWithLinesAsPromiseFromServer(organizationAreaId)
      .then(res => {
        $timeout(() => {
          $scope.organizationArea = OrganizationAreaService.Copy(res);
          $scope.getAssociatedProducts = defaultTo(get($scope.organizationArea, 'associatedProducts', []), []);
          const associatedProductsFiltered = selectProducts();
          $scope.associatedProductsToString = associatedProductsFiltered.map(product => product.name).toString();

          schedule.scheduleFormat($scope.organizationArea.schedule, $scope.exactSchedule);
          $scope.linesPopulated = res.organizationLinesPopulated;
          $scope.requestTypes = {
            value: {
              isWithoutAppointment: $scope.organizationArea.isWithoutAppointment,
              isWithAppointment: $scope.organizationArea.isWithAppointment,
            },
            isBA: $scope.enterpriseType === 'ba'
          };

          // Define initial editing status
          $scope.editStatus = {
            openEditingLines: false,
            openEditingWith: false,
            openEditingWithout: false,
            openEditingDayList: false,
            openAssociatedProducts: false,
            withoutAppointment: cloneDeep($scope.organizationArea.withoutAppointment),
            schedule: cloneDeep($scope.organizationArea.schedule),
            messages: cloneDeep($scope.organizationArea.configuration.messages),
            items: [],
          };

          // Fill item with lines
          for (let key in res.organizationLinesPopulated) {
            const item = {
              label: res.organizationLinesPopulated[key].label,
              _id: key, type: res.organizationLinesPopulated[key].type,
            };
            $scope.items.push(item);
            $scope.editStatus.items.push(item);
          }
          populateAlreadyShown();
          $scope.loader = false;
        });
      })
      .catch(ErrorService.handler);
  }else{
    $scope.loader = false;
  }

  $scope.save = data => {
    schedule.scheduleFormat($scope.organizationArea.schedule, $scope.exactSchedule, false);
    if (organizationAreaId && data) {
      const optionsSave = {};
      optionsSave.data = data;
      optionsSave.organizationAreaId = organizationAreaId;
      optionsSave.organizationId = $scope.organizationArea.organizationId;

      if (validate()) {
        $scope.blockSaveButton = true;

        return OrganizationAreaService.UpdatePartial(optionsSave)
          .then(() => {
            NotificationService.Success($translate.instant('area_update_succ'));
            return true;
          })
          .catch(error => {
            ErrorService.handler(error);
            $scope.blockSaveButton = false;
            return false;
          });
      }
    } else {
      $scope.organizationArea.organizationLines = $scope.items.map(item => item._id);
      $scope.organizationArea.associatedProducts = $scope.selectedProducts.map(product => product._id);      

      if (validate()) {
        $scope.blockSaveButton = true;

        return OrganizationAreaService.Create($scope.organizationArea)
          .then(() => {
            NotificationService.Success($translate.instant('area_create_succ'));
            $uibModalInstance.close('cancel');
          })
          .catch(error => {
            ErrorService.handler(error);
            $scope.blockSaveButton = false;
          });
      }
    };
  };

  // OSOM line selector
  $scope.selectLine = selection => {
    const itemSelected = {
      label: selection.name,
      _id: selection._id,
      type: selection.type,
      //realType: selection.realType,
      //statistics: selection.statistics,
      //waitingPeople: selection.waitingPeople
    };
    if (!includes($scope.items.map(item => item._id), selection._id)) {
      $scope.items.push(itemSelected);
    }
    populateAlreadyShown();
  };

  $scope.removeLine = lineId => {
    $scope.items = $scope.items.filter(item => item._id !== lineId);
    populateAlreadyShown();
  };

  $scope.setHasSecondPeriod = (day, hasSecondPeriod) => {
    day.hasSecondPeriod = hasSecondPeriod;
  };

  $scope.applyToAll = day => {
    schedule.applyToAll(day, $scope.organizationArea.schedule);
  };

  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };

  $scope.cancelEdit = attribute => {
    switch (attribute) {
      case 'withoutAppointment':
        $scope.editStatus.openEditingWithout = false;
        $scope.organizationArea.withoutAppointment = cloneDeep($scope.editStatus.withoutAppointment);
        break;

      case 'lines':
        $scope.editStatus.openEditingLines = false;
        $scope.items = cloneDeep($scope.editStatus.items);
        break;

      case 'schedule':
        $scope.editStatus.openEditingDayList = false;
        $scope.organizationArea.schedule = cloneDeep($scope.editStatus.schedule);
        break;

      case 'messages':
        $scope.editStatus.editingMessages = false;
        $scope.organizationArea.configuration.messages = cloneDeep($scope.editStatus.messages);
        break;
      case 'associatedProducts':
        $scope.editStatus.openAssociatedProducts = false;        
        break;

      default:
        break;
    }
  };

  $scope.title = 'processes';

  $scope.validateNumber = () => {
    let number = parseInt($scope.organizationArea.maxNumbers);
    number = isNaN(number) ? 0 : number;
    $scope.organizationArea.maxNumbers = number;
  };

  $scope.maxNumberKeyPress = e => {
    if (e.keyCode === 101 || e.keyCode === 69) {
      e.preventDefault();
    }
  };
};

module.exports = module.controller('OrganizationAreaModalController', OrganizationAreaModalController);
